"use strict";

const NewsSettingsCtrl = function (CRUDService, config) {
    var ctrl = this;

    var currentPage = 0;
    var totalPages;

    ctrl.$onInit = function() {
      CRUDService.getAll(config.urls.news).then(function (data) {
        ctrl.news = data._embedded.news;
        totalPages = data.page.totalPages;
      });
    };

    ctrl.remove = function (item) {
      CRUDService.remove(item._links.self.href).then(
        function () {
          ctrl.$onInit();
        });
    };

    ctrl.getNextPage = function () {
      if ((currentPage + 1) < totalPages) {
        currentPage++;
        CRUDService.getAll(config.urls.news, currentPage).then(function (data) {
          ctrl.news = ctrl.news.concat(data._embedded.news);
        });
      }
    };
  };

NewsSettingsCtrl.$inject = ['CRUDService', 'config'];

module.exports = {
  template: require('./news.html'),
  controller: NewsSettingsCtrl
};



// WEBPACK FOOTER //
// ./src/main/webapp-files/modules/settings/components/settings-news/settings-news.component.js